import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Heart, Phone, Star } from 'lucide-react';
import { useFavorites } from '@/context/FavoritesContext';

// Homepage-only presentation; category cards and their existing behaviour are untouched.
export default function DiscoveryPreview({business, list=false}) {
  const [failedImage, setFailedImage] = useState(null);
  const { isFavorite, toggleFavorite } = useFavorites();
  const saved = isFavorite(business.business_id);
  const label = business.food_type || (business.category === 'carhire' ? 'Car Hire' : business.category);
  return <article className={`dq-preview${list ? ' dq-preview-row' : ''}`}>
    <Link className="dq-preview-image" to={`/business/${business.business_id}`} tabIndex={-1} aria-hidden="true">
      {business.image_url && failedImage !== business.image_url ? <img src={business.image_url} onError={()=>setFailedImage(business.image_url)} alt="" loading="lazy"/> : <span className="dq-image-unavailable">Image unavailable</span>}
    </Link>
    <div className="dq-preview-copy">
      <div className="dq-preview-meta"><span>{label}</span>{business.is_featured && <span className="dq-featured">Featured</span>}</div>
      <h3><Link to={`/business/${business.business_id}`} data-testid={`${list ? 'business-card' : 'business-card-compact'}-${business.business_id}`}>{business.name}</Link></h3>
      {list && <p>{business.description}</p>}
      <div className="dq-preview-details">
        {business.rating != null && <span><Star size={12} aria-hidden="true"/>{Number(business.rating).toFixed(1)}{business.rating_count != null && ` (${business.rating_count})`}</span>}
        {business.is_open_now != null && <span>{business.is_open_now ? 'Open' : 'Closed'}</span>}
      </div>
    </div>
    <div className="dq-preview-actions">
      <button data-testid={`favorite-${business.business_id}`} type="button" onClick={()=>toggleFavorite(business.business_id)} aria-label={`${saved ? 'Unsave' : 'Save'} ${business.name}`} aria-pressed={saved}><Heart size={18} aria-hidden="true" fill={saved ? 'currentColor' : 'none'}/></button>
      {list && <button data-testid={`call-${business.business_id}`} type="button" onClick={()=>{window.location.href=`tel:${business.phone}`;}} aria-label={`Call ${business.name}`}><Phone size={18} aria-hidden="true"/></button>}
    </div>
  </article>;
}
